export default {"src":"https://cdn.jetlend.ru/_next/static/media/arrow--green-large.193f7d3b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};